const PromoCard = ({ result }) => {

    const CustomTag = result?.button?.link?.url ? `a` : 'div';

    return (
        <div className="op-promo-card">
            <CustomTag href={result?.button?.link?.url} className="op-promo-card__link">
                <div className="op-promo-card__content">
                    {result?.title && (
                        <h3 className="op-promo-card__title">{result.title}</h3>
                    )}
                    {result?.subtitle && (
                        <p className="op-promo-card__subtitle">{result.subtitle}</p>
                    )}
                    <div dangerouslySetInnerHTML={{ __html: result?.content }} />
                </div>

                {result?.image && (
                    <img
                        className="op-promo-card__img"
                        src={result?.image.url}
                        alt={result?.title}
                        srcSet={result?.image.srcSet}
                    />
                )}

                {result?.button?.link?.title && (
                    <div className="op-promo-card__footer">
                        <button className="op-promo-card__btn">
                            {result.button.link.title}
                        </button>
                    </div>
                )}
            </CustomTag>
        </div>
    );
};

export default PromoCard;
